var map = {
	"./admin-pages/admins/admins.module": [
		"./src/app/admin-pages/admins/admins.module.ts",
		"default~admin-pages-admins-admins-module~admin-pages-bids-bids-module~admin-pages-collections-collec~d3ab8489",
		"default~admin-pages-admins-admins-module~admin-pages-artists-artists-module~admin-pages-bids-bids-mo~616a1b82",
		"default~admin-pages-admins-admins-module~pages-pages-module",
		"common",
		"admin-pages-admins-admins-module"
	],
	"./admin-pages/artists/artists.module": [
		"./src/app/admin-pages/artists/artists.module.ts",
		"default~admin-pages-admins-admins-module~admin-pages-artists-artists-module~admin-pages-bids-bids-mo~616a1b82",
		"common",
		"admin-pages-artists-artists-module"
	],
	"./admin-pages/bids/bids.module": [
		"./src/app/admin-pages/bids/bids.module.ts",
		"default~admin-pages-admins-admins-module~admin-pages-bids-bids-module~admin-pages-collections-collec~d3ab8489",
		"default~admin-pages-admins-admins-module~admin-pages-artists-artists-module~admin-pages-bids-bids-mo~616a1b82",
		"default~admin-pages-bids-bids-module~admin-pages-collections-collections-module~admin-pages-create-n~94e59569",
		"default~admin-pages-bids-bids-module~admin-pages-nft-art-nft-art-module",
		"admin-pages-bids-bids-module"
	],
	"./admin-pages/collections/collections.module": [
		"./src/app/admin-pages/collections/collections.module.ts",
		"default~admin-pages-admins-admins-module~admin-pages-bids-bids-module~admin-pages-collections-collec~d3ab8489",
		"default~admin-pages-admins-admins-module~admin-pages-artists-artists-module~admin-pages-bids-bids-mo~616a1b82",
		"default~admin-pages-bids-bids-module~admin-pages-collections-collections-module~admin-pages-create-n~94e59569",
		"default~admin-pages-collections-collections-module~admin-pages-create-nft-create-nft-module~admin-pa~7cd09410",
		"common",
		"admin-pages-collections-collections-module"
	],
	"./admin-pages/create-nft/create-nft.module": [
		"./src/app/admin-pages/create-nft/create-nft.module.ts",
		"default~admin-pages-admins-admins-module~admin-pages-bids-bids-module~admin-pages-collections-collec~d3ab8489",
		"default~admin-pages-bids-bids-module~admin-pages-collections-collections-module~admin-pages-create-n~94e59569",
		"default~admin-pages-collections-collections-module~admin-pages-create-nft-create-nft-module~admin-pa~7cd09410",
		"common",
		"admin-pages-create-nft-create-nft-module"
	],
	"./admin-pages/dashboard/dashboard.module": [
		"./src/app/admin-pages/dashboard/dashboard.module.ts",
		"default~admin-pages-admins-admins-module~admin-pages-artists-artists-module~admin-pages-bids-bids-mo~616a1b82",
		"admin-pages-dashboard-dashboard-module"
	],
	"./admin-pages/events/events.module": [
		"./src/app/admin-pages/events/events.module.ts",
		"default~admin-pages-admins-admins-module~admin-pages-bids-bids-module~admin-pages-collections-collec~d3ab8489",
		"default~admin-pages-admins-admins-module~admin-pages-artists-artists-module~admin-pages-bids-bids-mo~616a1b82",
		"default~admin-pages-bids-bids-module~admin-pages-collections-collections-module~admin-pages-create-n~94e59569",
		"common",
		"admin-pages-events-events-module"
	],
	"./admin-pages/my-profile/my-profile.module": [
		"./src/app/admin-pages/my-profile/my-profile.module.ts",
		"default~admin-pages-admins-admins-module~admin-pages-bids-bids-module~admin-pages-collections-collec~d3ab8489",
		"admin-pages-my-profile-my-profile-module"
	],
	"./admin-pages/nft-art/nft-art.module": [
		"./src/app/admin-pages/nft-art/nft-art.module.ts",
		"default~admin-pages-admins-admins-module~admin-pages-bids-bids-module~admin-pages-collections-collec~d3ab8489",
		"default~admin-pages-admins-admins-module~admin-pages-artists-artists-module~admin-pages-bids-bids-mo~616a1b82",
		"default~admin-pages-bids-bids-module~admin-pages-collections-collections-module~admin-pages-create-n~94e59569",
		"default~admin-pages-collections-collections-module~admin-pages-create-nft-create-nft-module~admin-pa~7cd09410",
		"default~admin-pages-bids-bids-module~admin-pages-nft-art-nft-art-module",
		"default~admin-pages-nft-art-nft-art-module~admin-pages-sales-sales-module",
		"common",
		"admin-pages-nft-art-nft-art-module"
	],
	"./admin-pages/sales/sales.module": [
		"./src/app/admin-pages/sales/sales.module.ts",
		"default~admin-pages-admins-admins-module~admin-pages-bids-bids-module~admin-pages-collections-collec~d3ab8489",
		"default~admin-pages-admins-admins-module~admin-pages-artists-artists-module~admin-pages-bids-bids-mo~616a1b82",
		"default~admin-pages-bids-bids-module~admin-pages-collections-collections-module~admin-pages-create-n~94e59569",
		"default~admin-pages-collections-collections-module~admin-pages-create-nft-create-nft-module~admin-pa~7cd09410",
		"default~admin-pages-nft-art-nft-art-module~admin-pages-sales-sales-module",
		"admin-pages-sales-sales-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"default~admin-pages-admins-admins-module~admin-pages-bids-bids-module~admin-pages-collections-collec~d3ab8489",
		"default~admin-pages-admins-admins-module~pages-pages-module",
		"pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;